import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import PortalRoot from "../../PortalRunner/global/PortalRoot";
import { selectIsLoggedIn, selectIsLoading } from "../../Store/api/auth/authSelectors";
import { SignoutModal } from "../../Modal/SignoutModal/SignoutModal";
import { USER_APPLICATION_SESSION_KEY } from "../../MPP-Common-SPA/utils/globalUtility";
import { URL_SEARCH_PARAMS } from "../../MPP-Common-SPA/common/constants/urlParams";
import { ACTION_VALUES } from "../../MPP-Common-SPA/common/constants/values";
import { useDispatch } from "react-redux";
import { apiSlice } from "../../Store/api/apiSlice";

export const Apply = () => {
  const isLoading = useSelector(selectIsLoading);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const action = params.get(URL_SEARCH_PARAMS.Action);

  const showLogoutModal = action === ACTION_VALUES.Logout;

  useEffect(() => {
    if (action === ACTION_VALUES.Clear) {
      // Clear session storage
      sessionStorage.removeItem(USER_APPLICATION_SESSION_KEY);
      
      // Reset the entire API state to clear all cached data
      dispatch(apiSlice.util.resetApiState());
      
      // Navigate to clean apply page without any parameters
      navigate('/', { replace: true });
    }
  }, [action, dispatch, navigate]);

  return (
    <>
      <PortalRoot />
      <SignoutModal showModal={showLogoutModal && !isLoggedIn && !isLoading} />
    </>
  );
};
